module.exports = __webpack_public_path__ + "img/img-i5gam-tab2.766a92a0.png";